import { useEffect, useState } from "react";
import { AddUpdate } from "../../../ApiMethods/ApiMethods";
import { BsThreeDotsVertical } from "react-icons/bs";
import { Modal } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { get_CategoryRedirect } from "../../../store/actions/CommanAction";
import swal from "sweetalert";


const MostAcivityPage = () => {

	const [waitingsearchTerm, setwaitingSearchTerm] = useState('');
	const [freesearchTerm, setfreeSearchTerm] = useState('');
	const [waitinglistdata, setWaitingListdata] = useState([]);
	const [searchTerm1, setSearchTerm1] = useState('');
	const [freeAstrologerdata, setFreeAstrologerdata] = useState([]);
	const [userlistdata, setUserlistdata] = useState([]);
	const [transactiondata, setTransactiondata] = useState([]);

	const [postModel, setPostModel] = useState(false);
	const [title, setTitle] = useState("");
	const [message, setMessage] = useState("");
	const [redirect, setRedirect] = useState("");
	const [notificatinredirectvalue, setNotificationredctvalue] = useState("");
	const [userid, setUserid] = useState("");

	const CategoryNotificationData = useSelector(
		(state) => state.feedBackReducer?.CategoryRedirectData ?? []
	);
	const filterdata = CategoryNotificationData?.map((item) => item.Name);
	const dispatch = useDispatch();


	const [usersearchTerm, setuserSearchTerm] = useState("");
	const [userPage, setUserPage] = useState(1);
	const userRowsPerPage = 5;

	const filteredUserList = userlistdata.filter(item =>
		(item?.NickName?.toLowerCase().includes(usersearchTerm.toLowerCase())) ||
		(item?.UserID?.toString().includes(usersearchTerm)) ||
		(item?.Medium?.toLowerCase().includes(usersearchTerm.toLowerCase()))
	);

	const userTotalPages = Math.ceil(filteredUserList.length / userRowsPerPage);
	const userStartIndex = (userPage - 1) * userRowsPerPage;
	const userPaginatedData = filteredUserList.slice(userStartIndex, userStartIndex + userRowsPerPage);

	const userNextPage = () => {
		if (userPage < userTotalPages) setUserPage(userPage + 1);
	};

	const userPrevPage = () => {
		if (userPage > 1) setUserPage(userPage - 1);
	};



	const filteredTransactions = transactiondata.filter(item =>
		item?.UserName?.toLowerCase().includes(searchTerm1.toLowerCase()) ||
		
		item?.payment_status?.toLowerCase().includes(searchTerm1.toLowerCase())
	);

	const transactionPageSize = 5;
	const [transactionPage, setTransactionPage] = useState(1);

	const transactionTotalPages = Math.ceil(filteredTransactions.length / transactionPageSize);
	const transactionStartIndex = (transactionPage - 1) * transactionPageSize;
	const transactionPaginated = filteredTransactions.slice(
		transactionStartIndex,
		transactionStartIndex + transactionPageSize
	);

	const transactionNext = () => {
		if (transactionPage < transactionTotalPages) setTransactionPage(transactionPage + 1);
	};

	const transactionPrev = () => {
		if (transactionPage > 1) setTransactionPage(transactionPage - 1);
	};



	const filteredWaiting = waitinglistdata.filter(item =>
		item?.AstroName?.toLowerCase().includes(waitingsearchTerm.toLowerCase()) ||
		item?.UserName?.toLowerCase().includes(waitingsearchTerm.toLowerCase()) ||
		item?.Type?.toLowerCase().includes(waitingsearchTerm.toLowerCase())
	);

	const waitingPageSize = 5;
	const [waitingPage, setWaitingPage] = useState(1);

	const waitingTotalPages = Math.ceil(filteredWaiting.length / waitingPageSize);
	const waitingStartIndex = (waitingPage - 1) * waitingPageSize;
	const waitingPaginated = filteredWaiting.slice(
		waitingStartIndex,
		waitingStartIndex + waitingPageSize
	);

	const waitingNext = () => {
		if (waitingPage < waitingTotalPages) setWaitingPage(waitingPage + 1);
	};

	const waitingPrev = () => {
		if (waitingPage > 1) setWaitingPage(waitingPage - 1);
	};



	const filteredFree = freeAstrologerdata.filter(item =>
		item?.DisplayName?.toLowerCase().includes(freesearchTerm.toLowerCase()) ||
		item?.PricePerMin?.toString().includes(freesearchTerm) ||
		item?.FreeState?.toString().includes(freesearchTerm)
	);

	const freePageSize = 5;
	const [freePage, setFreePage] = useState(1);

	const freeTotalPages = Math.ceil(filteredFree.length / freePageSize);
	const freeStartIndex = (freePage - 1) * freePageSize;
	const freePaginated = filteredFree.slice(
		freeStartIndex,
		freeStartIndex + freePageSize
	);

	const freeNext = () => {
		if (freePage < freeTotalPages) setFreePage(freePage + 1);
	};

	const freePrev = () => {
		if (freePage > 1) setFreePage(freePage - 1);
	};






	const waitinglistfunction = async () => {

		try {
			const data = { Status: "", UserID: "", AstroID: "" };
			const res = await AddUpdate("WaitingList/GetData_WaitingList", data);
			if (res?.data?.data) {
				const datas = JSON?.parse(res?.data?.data);
				const finaldata = datas?.Table;

				setWaitingListdata(finaldata)
			}
			else {
				setWaitingListdata([])
			}
		}
		catch (err) {
			console.log("error", err)
		}
	}


	const Freelistfunction = async () => {

		try {
			const data = {
				// CreatedFrom: new Date().toISOString().split("T")[0], CreatedTo: new Date().toISOString().split("T")[0],
				IsActive: true, FreeState: 0, IsVerified: 1
			};
			const res = await AddUpdate("Astrologer/GetData_Astrologer", data);
			if (res?.data?.data) {
				const datas = JSON?.parse(res?.data?.data);
				const finaldata = datas?.Table;

				setFreeAstrologerdata(finaldata)
			}
			else {
				setFreeAstrologerdata([])
			}
		}
		catch (err) {
			console.log("error", err)
		}
	}

	const Userlist = async () => {

		try {
			const data = { CreatedFrom: new Date().toISOString().split("T")[0], CreatedTo: new Date().toISOString().split("T")[0], IsActive: true };
			const res = await AddUpdate("User/GetData_User", data);
			if (res?.data?.data) {
				const datas = JSON?.parse(res?.data?.data);
				const finaldata = datas?.Table;


				setUserlistdata(finaldata)
			}
			else {
				setUserlistdata([])
			}
		}
		catch (err) {
			console.log("error", err)
		}
	}

	const transactionlist = async () => {

		try {
			const data = {
				Datetimefrom: new Date().toISOString().split("T")[0], Datetimeto: new Date().toISOString().split("T")[0],
				Type: "captured"
			};
			const res = await AddUpdate("ChatHistory/ChatCallTransaction", data);
			if (res?.data?.data) {
				const datas = JSON?.parse(res?.data?.data);
				const finaldata = datas?.Table;

				setTransactiondata(finaldata)
			}
			else {
				setTransactiondata([])
			}
		}
		catch (err) {
			console.log("error", err)
		}
	}

	const refreshAllData = () => {
		waitinglistfunction();
		Freelistfunction();
		Userlist();
		transactionlist();
	};

	useEffect(() => {
		refreshAllData();
	}, [])

	useEffect(() => {
		refreshAllData();

		const interval = setInterval(() => {
			refreshAllData();
		}, 300000); 

		return () => clearInterval(interval);
	}, []);

	const DeleteWaitinglist = async (astroId, userId) => {
		try {
			const data = { AstroID: astroId, UserID: userId };

			const res = await AddUpdate("WaitingList/Delete_WaitingList", data);

			if (res) {
				waitinglistfunction();
			}

		} catch (error) {
			console.log("error", error);
		}
	};


	const formatUsingIntl = (str) => {
		return new Intl.DateTimeFormat("en-US", {
			dateStyle: "short",
			timeStyle: "medium",
			hour12: true,
		}).format(new Date(str));
	};


	const onchanges = (e) => {
		setNotificationredctvalue(e.target.value);
	};
	useEffect(() => {
		dispatch(get_CategoryRedirect())
	}, [])
	const notificationopen = (id) => {
		setUserid(id);

		setPostModel(true);
	}
	const reset = () => {
		setTitle("");
		setMessage("");
		setNotificationredctvalue("");

	}
	const handleSubmit = async () => {
		try {

			if (!title || !title.trim()) {
				swal("Missing Title", "Please enter a notification title.", "warning");
				return;
			}


			if (!message || !message.trim()) {
				swal("Missing Message", "Please enter a message for the notification.", "warning");
				return;
			}


			const postData = {
				Title: title.trim(),
				Body: message.trim(),
				UserID: userid,
				IsMail: false,
				IsNotification: true,
				ImageUrl: "",
				Redirect: notificatinredirectvalue.trim(),
				AstroId: 0,
			};


			const response = await AddUpdate("Notifications/Send_Notification", postData);


			if (response) {
				swal("Good job!", "Notification sent successfully!", "success");
				setPostModel(false);
				reset();
			} else {
				swal("Error", response?.message || "Failed to send notification.", "error");
			}

		} catch (error) {
			console.error("Error sending notification:", error);
			swal("Error", "Something went wrong while sending the notification.", "error");
		}

	};



	return (
		<>

			<div
				style={{
					display: "flex",
					justifyContent: "space-between",
					alignItems: "center",
					marginBottom: "20px",
				}}
			>

				<h2 style={{ color: "#f7931e", fontWeight: 700, margin: 0 }}>
					Today Activity Page
				</h2>


				<button
					className="btn btn-sm btn-outline-primary"
					onClick={refreshAllData}
				>
					Refresh Page
				</button>

			</div>


			<div className='col-xl-12'>
				<div className='row g-4'>

					<div className='col-lg-6 col-md-12 mb-4'>
						<div className='card shadow-sm' style={{ border: "1px solid #e5e7eb", borderRadius: '12px' }}>
							<div className="card-body">
								<div className="d-flex justify-content-between align-items-center mb-3">
									<h5 className="mb-0 fs-20"> UserList</h5>
									<input
										type="text"
										placeholder="Search..."
										className="form-control w-25"
										value={usersearchTerm}
										onChange={(e) => setuserSearchTerm(e.target.value)}
									/>
								</div>

								<table className="table align-middle mb-3">
									<thead style={{ backgroundColor: '#f4f6f9' }}>
										<tr>
											<th className="text-secondary fw-semibold">Notification</th>
											<th className="text-secondary fw-semibold">User Name</th>
											<th className="text-secondary fw-semibold">Medium</th>
											<th className="text-secondary fw-semibold">Wallet Amt</th>
											<th className="text-secondary fw-semibold">Chats</th>
											<th className="text-secondary fw-semibold">Calls</th>
										</tr>
									</thead>
									<tbody style={{ fontSize: "13px", color: "black" }}>
										{userlistdata?.length > 0 ? (
											userPaginatedData?.map((employee) => (
												<tr key={employee?.id}>
													{/* <td><span onClick={()=>setPostModel(true)} ><BsThreeDotsVertical /></span></td> */}
													<td>{<button className="btn btn-primary" onClick={() => notificationopen(employee?.UserID)} >Send</button>}</td>
													<td>{employee?.NickName}({employee?.UserID})</td>
													<td>
														<div className="d-flex flex-column">
															<span>{employee?.Medium} </span>

														</div>
													</td>
													<td>{employee?.WalletAmt}</td>
													<td>{employee?.TotalChats}</td>
													<td>{employee?.TotalCalls}</td>

												</tr>
											))
										) : (
											<tr>
												<td colSpan="6" className="text-center text-muted">No Records Found</td>
											</tr>
										)}
									</tbody>
								</table>

								<div className="d-flex justify-content-between align-items-center">
									<p style={{ fontSize: "12px", color: "black" }}>
										Showing {userPaginatedData.length} of {filteredUserList.length} entries
									</p>
									<div className="d-flex align-items-center gap-2">

										<button
											className="btn btn-sm btn-outline-primary"
											disabled={userPage === 1}
											onClick={userPrevPage}
										>
											←
										</button>

										<span className="text-muted">
											{userPage} / {userTotalPages}
										</span>

										<button
											className="btn btn-sm btn-outline-primary"
											disabled={userPage === userTotalPages}
											onClick={userNextPage}
										>
											→
										</button>

									</div>

								</div>
							</div>
						</div>
					</div>

					<div className='col-lg-6 col-md-12 mb-4'>
						<div className='card shadow-sm' style={{ border: "1px solid #e5e7eb", borderRadius: '12px' }}>
							<div className="card-body">
								<div className="d-flex justify-content-between align-items-center mb-3">
									<h5 className="mb-0 fs-20">Waiting List</h5>
									<input
										type="text"
										placeholder="Search..."
										className="form-control w-25"
										value={waitingsearchTerm}
										onChange={(e) => setwaitingSearchTerm(e.target.value)}
									/>
								</div>

								<table className="table align-middle mb-3">
									<thead style={{ backgroundColor: '#f4f6f9' }}>
										<tr>
											<th className="text-secondary fw-semibold">Astro Name</th>
											<th className="text-secondary fw-semibold">UserName</th>
											<th className="text-secondary fw-semibold">Type</th>
											<th className="text-secondary fw-semibold">Status</th>
											<th className="text-secondary fw-semibold">Free</th>
											<th className="text-secondary fw-semibold">Time</th>
											<th className="text-secondary fw-semibold">Delete</th>
										</tr>
									</thead>
									<tbody style={{ fontSize: "13px", color: "black" }}>
										{waitinglistdata?.length > 0 ? (
											waitingPaginated?.map((employee) => (
												<tr key={employee?.id}>
													<td>{employee?.AstroName}({employee?.AstroID})</td>
													<td>
														<div className="d-flex flex-column">
															<span>{employee?.UserName}({employee?.UserID})</span>

														</div>
													</td>
													<td>{employee?.Type}</td>
													<td>{employee?.Status}</td>
													<td>
														{employee?.IsFree
															? employee.IsFree === "Free"
																? "Free"
																: "Paid"
															: "-"}
													</td>
													<td>{employee?.CreatedDate}</td>

													<td>
														<button
															className="btn btn-sm btn-danger"
															onClick={() => DeleteWaitinglist(employee?.AstroID, employee?.UserID)}
														>
															Delete
														</button>
													</td>

												</tr>
											))
										) : (
											<tr>
												<td colSpan="7" className="text-center text-muted">No Records Found</td>
											</tr>
										)}
									</tbody>
								</table>

								<div className="d-flex justify-content-between align-items-center">
									<p style={{ fontSize: "12px", color: "black" }} >
										Showing {waitingPaginated.length} of {filteredWaiting.length} entries
									</p>
									<div className="d-flex align-items-center gap-2">

										<button
											className="btn btn-sm btn-outline-primary"
											disabled={waitingPage === 1}
											onClick={waitingPrev}
										>
											←
										</button>

										<span className="text-muted">
											{waitingPage} / {waitingTotalPages}
										</span>

										<button
											className="btn btn-sm btn-outline-primary"
											disabled={waitingPage === waitingTotalPages}
											onClick={waitingNext}
										>
											→
										</button>

									</div>

								</div>
							</div>
						</div>
					</div>


				</div>
			</div>


			<div className='col-xl-12'>
				<div className='row g-4'>

					<div className='col-lg-6 col-md-12 mb-4'>
						<div className='card shadow-sm' style={{ border: "1px solid #e5e7eb", borderRadius: '12px' }}>
							<div className="card-body">
								<div className="d-flex justify-content-between align-items-center mb-3">
									<h5 className="mb-0 fs-20">Transaction</h5>
									<input
										type="text"
										placeholder="Search..."
										className="form-control w-25"
										value={searchTerm1}
										onChange={(e) => setSearchTerm1(e.target.value)}
									/>
								</div>

								<table className="table align-middle mb-3">
									<thead style={{ backgroundColor: '#f4f6f9' }}>
										<tr>
											<th className="text-secondary fw-semibold">UserName </th>
											<th className="text-secondary fw-semibold">Amount</th>
											<th className="text-secondary fw-semibold">Status</th>

										</tr>
									</thead>
									<tbody style={{ fontSize: "13px", color: "black" }}>
										{transactiondata?.length > 0 ? (
											transactionPaginated?.map((employee) => (
												<tr key={employee?.id}>
													<td>{employee?.UserName}({employee?.userId})</td>
													<td>
														<div className="d-flex flex-column">
															<span>{employee?.payment_amount}</span>

														</div>
													</td>
													<td>{employee?.payment_status}</td>
												</tr>
											))
										) : (
											<tr>
												<td colSpan="3" className="text-center text-muted">No Records Found</td>
											</tr>
										)}
									</tbody>
								</table>

								<div className="d-flex justify-content-between align-items-center">
									<p style={{ fontSize: "12px", color: "black" }}>
										Showing {transactionPaginated.length} of {filteredTransactions.length} entries
									</p>
									<div className="d-flex align-items-center gap-2">
										<button className="btn btn-sm btn-outline-primary" disabled={transactionPage === 1} onClick={transactionPrev}>←</button>
										<span>{transactionPage} / {transactionTotalPages}</span>
										<button className="btn btn-sm btn-outline-primary" disabled={transactionPage === transactionTotalPages} onClick={transactionNext}>→</button>
									</div>

								</div>
							</div>
						</div>
					</div>

					<div className='col-lg-6 col-md-12 mb-4'>
						<div className='card shadow-sm' style={{ border: "1px solid #e5e7eb", borderRadius: '12px' }}>
							<div className="card-body">
								<div className="d-flex justify-content-between align-items-center mb-3">
									<h5 className="mb-0 fs-20">Free Astrologers</h5>
									<input
										type="text"
										placeholder="Search..."
										className="form-control w-25"
										value={freesearchTerm}
										onChange={(e) => setfreeSearchTerm(e.target.value)}
									/>
								</div>

								<table className="table align-middle mb-3">
									<thead style={{ backgroundColor: '#f4f6f9' }}>
										<tr>
											<th className="text-secondary fw-semibold">Astro Name</th>
											<th className="text-secondary fw-semibold">Price</th>
											<th className="text-secondary fw-semibold">FreePrice</th>
											<th className="text-secondary fw-semibold">Type</th>
										</tr>
									</thead>
									<tbody style={{ fontSize: "13px", color: "black" }}>
										{freeAstrologerdata?.length > 0 ? (
											freePaginated?.map((employee) => (
												<tr key={employee?.id}>
													<td>{employee?.DisplayName}({employee?.ID})</td>
													<td>
														<div className="d-flex flex-column">
															<span>{employee?.PricePerMin} </span>

														</div>
													</td>
													<td>{employee?.FreeEarningAmount}</td>
													<td>{employee?.FreeState ? "Not Free" : "Free"}</td>
												</tr>
											))
										) : (
											<tr>
												<td colSpan="4" className="text-center text-muted">No Records Found</td>
											</tr>
										)}
									</tbody>
								</table>

								<div className="d-flex justify-content-between align-items-center">
									<p style={{ fontSize: "12px", color: "black" }}>
										Showing {freePaginated.length} of {filteredFree.length} entries
									</p>
									<div className="d-flex align-items-center gap-2">

										<button
											className="btn btn-sm btn-outline-primary"
											disabled={freePage === 1}
											onClick={freePrev}
										>
											←
										</button>

										<span className="text-muted">
											{freePage} / {freeTotalPages}
										</span>

										<button
											className="btn btn-sm btn-outline-primary"
											disabled={freePage === freeTotalPages}
											onClick={freeNext}
										>
											→
										</button>

									</div>

								</div>
							</div>
						</div>
					</div>
				</div>
			</div>




			<Modal
				className="modal fade"
				size="xl"
				show={postModel}
				onHide={() => setPostModel(false)}
				backdrop="static"
			>
				<div className="row g-0">

					<div className="col-md-6 p-4">
						<div
							className="shadow"
							style={{ borderRadius: "12px", border: "1px solid #e5e7eb" }}
						>
							<div style={{ padding: "1.5rem" }}>
								<h5 className="mb-4 fw-bold" style={{ fontSize: "20px" }}>
									Create Notification
								</h5>


								<div className="mb-3">
									<div className="form-group">
										<input
											type="text"
											placeholder="Notification Title"
											value={title}
											onChange={(e) => setTitle(e.target.value)}
										/>
									</div>
								</div>


								<div className="mb-3">
									<div className="form-group">
										<textarea
											placeholder="Enter your message..."
											rows="4"
											value={message}
											onChange={(e) => setMessage(e.target.value)}
										/>
									</div>
								</div>



								<div className="mb-3">
									<div className="form-group">
										<select
											onChange={onchanges}
										>
											<option disabled selected value="">
												Notification Redirect
											</option>
											{filterdata?.map((item, index) => (
												<option key={index} value={item}>
													{item}
												</option>
											))}
										</select>
									</div>
								</div>




								<div className="d-flex justify-content-end mt-2">
									<button
										className="btn me-2"
										style={{
											backgroundColor: "#ff6f00",
											color: "#fff",
											fontWeight: 600,
											width: "150px",
										}}
										onClick={handleSubmit}
									>
										Send Notification
									</button>

									<button
										className="btn"
										style={{
											backgroundColor: "red",
											color: "#fff",
											fontWeight: 600,
											width: "150px",
										}}
										onClick={() => setPostModel(false)}
									>
										Close
									</button>
								</div>
							</div>
						</div>
					</div>


					<div
						className="col-md-6 d-flex align-items-center justify-content-center"
						style={{ background: "#f9fafb", borderLeft: "1px solid #ddd" }}
					>
						<div
							style={{
								width: "350px",
								border: "1px solid #ccc",
								borderRadius: "10px",
								padding: "15px",
								background: "#fff",
								boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
							}}
						>

							<div className="d-flex justify-content-between align-items-center">
								<div
									style={{
										fontWeight: "bold",
										display: "flex",
										alignItems: "center",
									}}
								>

									AstroCall
								</div>
								<span style={{ cursor: "pointer" }}>×</span>
							</div>


							<div style={{ fontSize: "14px", marginTop: "8px" }}>
								<strong>{title || "Notification Title"}</strong>
							</div>


							<div style={{ fontSize: "13px", color: "#555" }}>
								{message || "Your message will appear here..."}
							</div>
						</div>
					</div>
				</div>
			</Modal>



		</>
	)
}
export default MostAcivityPage;